import { AppStates } from "utils/helpers/app.helpers"
import withProtectedRoute from "utils/hocs/withProtectedRoute"
import MyGpsContainer from "../../../containers/MyGps/MyGpsContainer/MyGpsContainer"

const MyGpsScreen = () => {
  return <MyGpsContainer />
}

export default withProtectedRoute(MyGpsScreen, AppStates.homeState)
